<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="error"
        v-on="on"
      >
        Delete current batch
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Delete Batch"
      text="Delete Batch"
      class="mb-0"
    >
      <v-card-text> Are you sure you want to <b class="font-weight-bold">CURRENT</b> batch?</v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      batchId: {
        type: Number,
        required: true,
      },    
    },
    data () {
      return {
        progressing: false,
        dialog: null,
      }
    },

    methods: {
      submitForm () {
        this.progressing = true

        this.$api.companySalaryBatch().destroy(this.batchId)
          .then(response => {
            this.$snack({ message: 'Batch Deleted' })
            this.$emit('deleted')

            this.progressing = false
            this.dialog = false
          })
          .catch(() => {
            this.progressing = false
          })
      },

    },
  }
</script>
